import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authApi } from '../admin/api';
import { PARTNER_CATEGORIES } from './categories';

function fmtDetail(d) {
  if (!d) return 'Registrazione non riuscita';
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || '').join(' ');
  return String(d);
}

const inputCls = 'w-full rounded-lg border border-paelbi-line bg-white px-3 py-2.5 text-sm text-paelbi-ink outline-none focus:border-paelbi-brown';

export function PartnerRegister() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const plan = params.get('plan') || '';
  const [form, setForm] = useState({ name: '', business_name: '', category: 'Ristoranti', email: '', password: '', phone: '' });
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setErr(''); setBusy(true);
    try {
      await authApi.registerPartner({ ...form, plan: plan || undefined });
      navigate('/partner', { replace: true });
    } catch (e2) {
      setErr(fmtDetail(e2.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-paelbi-bg px-4 py-10">
      <div className="w-full max-w-md rounded-2xl border border-paelbi-line bg-white p-8 shadow-card" data-testid="partner-register-card">
        <div className="mb-6 text-center">
          <h1 className="font-display text-2xl text-paelbi-ink">Diventa Partner Domira</h1>
          <p className="mt-1 text-sm text-paelbi-ink/60">
            {plan ? `Piano ${plan} · 30 giorni di prova gratuita` : 'Registra la tua attività · 30 giorni di prova gratuita'}
          </p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div><label className="mb-1 block text-sm font-medium text-paelbi-ink/80">Il tuo nome</label>
            <input value={form.name} onChange={set('name')} required minLength={2} className={inputCls} data-testid="partner-name" /></div>
          <div><label className="mb-1 block text-sm font-medium text-paelbi-ink/80">Nome attività</label>
            <input value={form.business_name} onChange={set('business_name')} required minLength={2} className={inputCls} data-testid="partner-business-name" /></div>
          <div><label className="mb-1 block text-sm font-medium text-paelbi-ink/80">Categoria</label>
            <select value={form.category} onChange={set('category')} className={inputCls} data-testid="partner-category">
              {PARTNER_CATEGORIES.map((c) => <option key={c} value={c}>{c}</option>)}
            </select></div>
          <div><label className="mb-1 block text-sm font-medium text-paelbi-ink/80">Telefono (opzionale)</label>
            <input value={form.phone} onChange={set('phone')} className={inputCls} data-testid="partner-phone" /></div>
          <div><label className="mb-1 block text-sm font-medium text-paelbi-ink/80">Email</label>
            <input type="email" value={form.email} onChange={set('email')} required className={inputCls} data-testid="partner-email" /></div>
          <div><label className="mb-1 block text-sm font-medium text-paelbi-ink/80">Password</label>
            <input type="password" value={form.password} onChange={set('password')} required minLength={6} className={inputCls} data-testid="partner-password" /></div>
          {err && <p className="text-sm text-red-600" data-testid="partner-register-error">{err}</p>}
          <button type="submit" disabled={busy} data-testid="partner-register-submit"
            className="h-11 w-full rounded-btn bg-paelbi-brown font-semibold text-white transition-colors hover:bg-paelbi-brown-dark disabled:opacity-60">
            {busy ? 'Creazione...' : 'Inizia la prova gratuita'}
          </button>
        </form>
        <p className="mt-6 text-center text-sm text-paelbi-ink/60">
          Hai già un account? <a href="/admin/login" className="font-semibold text-paelbi-brown">Accedi</a>
        </p>
      </div>
    </div>
  );
}

export default PartnerRegister;
